/**
 * idIn による単体拠点解決時のクエリパラメータ。
 * place-select API は idIn 指定時にステータスフィルタを適用しない。
 */
export function buildPlaceSelectByIdInQueryParams(placeId: string) {
  return {
    idIn: [placeId],
    pageSize: 1,
    getAddress: false,
    getPhone: false,
    getEmail: false,
  };
}
